import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';

import * as io from 'socket.io-client';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SocketioService {
  socket: any;
  socketStatus = false;

  constructor() {
   this.setupSocketConnection();
   // this.checkstatus();
  }

  setupSocketConnection() {
    this.socket = io(environment.SOCKET_ENDPOINT, {transports: ['polling']});

}


listen( evento: string) { 
 // return this.socket.fronteve ( evento );
 return new Observable ((Subscriber) => {
    this.socket.on (evento,(data)=> {
      Subscriber.next (data);
    });
 });
}

emit( evento: string, payload?: any, callback?: Function) {
  // console.log ('EmitienodEventos', evento);
   this.socket.emit (evento, payload , callback);
}



checkstatus() {
  this.socket.on ('connect', () => {
  //  console.log ('conectado la servidor');
    this.socketStatus = true;
  });

  this.socket.on ('disconnect', () => {
  //  console.log ('Desconecatdo la servidor');
    this.socketStatus = false;
  });

}












}



